import styled, { css } from 'styled-components';

import {
  spaceXS,
  xdlColorError,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

import type { HintVariant } from '.';

type IconContainerTProps = {
  $variant?: HintVariant;
};

type TextTProps = {
  $variant?: HintVariant;
};

// *** Variants ***
export const variants = {
  error: css`
    && {
      color: ${xdlColorError};
    }
  `,
  info: css`
    && {
      color: ${xdlColorTextSecondary};
    }
  `,
};

// *** Components ***
export const Hint = styled.div`
  align-items: start;
  display: flex;
  gap: ${spaceXS};
  justify-content: center;
`;

export const IconContainer = styled.div<IconContainerTProps>`
  ${({ $variant }) => {
    switch ($variant) {
      case 'info':
        return variants.info;
      case 'error':
        return variants.error;
      default:
        return $variant satisfies undefined;
    }
  }}
`;

export const Text = styled(Meta)<TextTProps>`
  /* A visual fix to make the first line be better aligned and still keep the dense line-height */
  padding-top: 0.1em;

  ${({ $variant }) => {
    switch ($variant) {
      case 'info':
        return variants.info;
      case 'error':
        return variants.error;
      default:
        return $variant satisfies undefined;
    }
  }}
`;
